import dictionaryEntriesAPI from 'dashboard/api/helpCenter/dictionaryEntries.js';
import { throwErrorMessage } from 'dashboard/store/utils/api';
import types from './types';

export const actions = {
  index: async ({ commit }, { portalSlug }) => {
    if (!portalSlug) return [];
    commit(types.SET_UI_FLAG, { isFetching: true });
    try {
      const {
        data: { payload },
      } = await dictionaryEntriesAPI.get({ portalSlug });
      commit(types.SET_ENTRIES, payload);
      return payload;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.SET_UI_FLAG, { isFetching: false });
    }
  },

  create: async ({ commit }, { portalSlug, entryObj }) => {
    commit(types.SET_UI_FLAG, { isCreating: true });
    try {
      const {
        data: { payload },
      } = await dictionaryEntriesAPI.create({ portalSlug, entryObj });
      commit(types.ADD_ENTRY, payload);
      return payload;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.SET_UI_FLAG, { isCreating: false });
    }
  },

  update: async ({ commit }, { portalSlug, entryId, entryObj }) => {
    commit(types.SET_UI_FLAG, { isUpdating: true });
    try {
      const {
        data: { payload },
      } = await dictionaryEntriesAPI.update({ portalSlug, entryId, entryObj });
      commit(types.UPDATE_ENTRY, payload);
      return payload;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.SET_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async ({ commit }, { portalSlug, entryId }) => {
    commit(types.SET_UI_FLAG, { isDeleting: true });
    try {
      await dictionaryEntriesAPI.delete({ portalSlug, entryId });
      commit(types.REMOVE_ENTRY, entryId);
      return entryId;
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.SET_UI_FLAG, { isDeleting: false });
    }
  },

  // Translates a single term into every other portal locale in one LLM call; returns
  // a { locale: term } map for the editor to prefill.
  translate: async ({ commit }, { portalSlug, term }) => {
    commit(types.SET_UI_FLAG, { isTranslating: true });
    try {
      const { data } = await dictionaryEntriesAPI.translate({
        portalSlug,
        term,
      });
      return data.translations || {};
    } catch (error) {
      return throwErrorMessage(error);
    } finally {
      commit(types.SET_UI_FLAG, { isTranslating: false });
    }
  },
};
